//GET_APP_TRACK_LIST
export const GET_APP_TRACK_LIST_REQUEST = 'GET_APP_TRACK_LIST_REQUEST';
export const GET_APP_TRACK_LIST_SUCCESS = 'GET_APP_TRACK_LIST_SUCCESS';
export const GET_APP_TRACK_LIST_FAIL = 'GET_APP_TRACK_LIST_FAIL';

//GET_APP_TRACK_BY_DATE_LIST
export const GET_APP_TRACK_BY_DATE_LIST_REQUEST = 'GET_APP_TRACK_BY_DATE_LIST_REQUEST';
export const GET_APP_TRACK_BY_DATE_LIST_SUCCESS = 'GET_APP_TRACK_BY_DATE_LIST_SUCCESS';
export const GET_APP_TRACK_BY_DATE_LIST_FAIL = 'GET_APP_TRACK_BY_DATE_LIST_FAIL';